/* eslint-disable react-hooks/exhaustive-deps */
import { Checkbox, FormControlLabel } from "@mui/material";
import React, { useEffect, useState } from "react";
import AppInput from "../common/AppInput";
import findTimeStep from "../hooks/findTimeStep";
import moment from "moment";
import AppButton from "../common/AppButton";
import { AiOutlineMinus, AiOutlinePlus } from "react-icons/ai";
const DayTimeSlot = ({ day, setDayTime, value, showMode }) => {
  const [times, setTimes] = useState(
    value || [
      {
        from: {
          time: "12:00am",
        },
        to: { time: "12:00am" },
      },
    ]
  );

  useEffect(() => {
    if (value) {
      setTimes(value.times);
      setChecked(value.available);
    }
  }, [value]);

  const handleChange = ({ target }, ind) => {
    const name = target.name;
    const value = target.value;
    const items = [...times];

    if (name === "from") {
      if (
        moment(items[ind].to?.time, "hh:mma").valueOf() <
        moment(value.time, "hh:mma").valueOf()
      ) {
        items[ind].to = value;
      }
    }
    items[ind][name] = value;
    setDayTime({ day, times, checked });
    setTimes(items);
  };
  const [checked, setChecked] = useState(false);
  if (showMode && !checked) return false;

  return (
    <div
      className="d-flex"
      style={{
        alignItems: "flex-start",
        // width: "100%",
      }}
    >
      <div style={{ marginTop: 20, minWidth: 150 }}>
        <FormControlLabel
          control={
            <Checkbox
              readOnly={showMode}
              checked={checked}
              onChange={(_, value) => {
                if (!showMode) {
                  setDayTime({ day, times, checked: value });
                  setChecked(value);
                }
              }}
              name="checkedB"
              color="primary"
            />
          }
          label={day}
        />
      </div>
      <div>
        {times.map((item, ind) => {
          const last = ind === times.length - 1;
          return (
            <div
              key={String(ind)}
              className="d-flex"
              style={{
                alignItems: "center",
                height: 60,
              }}
            >
              <div style={{ marginRight: 10 }}>
                <AppInput
                  showMode={showMode}
                  type="dropdown"
                  noClear
                  placeholder="From"
                  options={findTimeStep({
                    steps: 30,
                    start: times[ind - 1]?.to?.time,
                  })}
                  onChange={(event) => {
                    handleChange(event, ind);
                  }}
                  name="from"
                  value={item.from}
                  filterBy="time"
                />
              </div>
              <div style={{ marginTop: 3 }}> - </div>
              <div style={{ marginLeft: 10 }}>
                <AppInput
                  type="dropdown"
                  noClear
                  placeholder="To"
                  showMode={showMode}
                  onChange={(event) => {
                    handleChange(event, ind);
                  }}
                  name="to"
                  options={findTimeStep({ steps: 30, start: item.from.time })}
                  value={item.to}
                  filterBy="time"
                />
              </div>
              {!showMode && last && (
                <div
                  className="d-flex"
                  style={{ marginLeft: 10, marginTop: 8 }}
                >
                  <AppButton
                    onClick={() => {
                      const timex = [
                        ...times,
                        {
                          from: {
                            time: item.to.time,
                          },
                          to: { time: item.to.time },
                        },
                      ];
                      setTimes(timex);

                      setDayTime({
                        day,
                        times: timex,
                        checked,
                      });
                    }}
                    leftIcon={<AiOutlinePlus />}
                  />
                  {ind !== 0 && (
                    <AppButton
                      onClick={() => {
                        setTimes([
                          ...times.slice(0, ind),
                          ...times.slice(ind + 1),
                        ]);

                        setDayTime({
                          day,
                          times: [
                            ...times.slice(0, ind),
                            ...times.slice(ind + 1),
                          ],
                          checked,
                        });
                      }}
                      leftIcon={<AiOutlineMinus />}
                    />
                  )}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default function DayTimeSlots({
  onChange,
  defaultValue = [],
  showMode,
}) {
  useEffect(() => {
    const obj = {};
    for (const item of defaultValue) {
      obj[item.day] = item;
    }
    setDt(obj);
  }, []);

  const [dt, setDt] = useState({});
  const handleChange = ({ day, times, checked }) => {
    setDt({ ...dt, [day]: { times, available: checked, day } });
    onChange && onChange({ ...dt, [day]: { times, available: checked, day } });
  };

  return (
    <div>
      <DayTimeSlot
        showMode={showMode}
        day="Monday"
        setDayTime={handleChange}
        value={dt["Monday"]}
      />
      <DayTimeSlot
        showMode={showMode}
        day="Tuesday"
        setDayTime={handleChange}
        value={dt["Tuesday"]}
      />
      <DayTimeSlot
        showMode={showMode}
        day="Wednesday"
        setDayTime={handleChange}
        value={dt["Wednesday"]}
      />
      <DayTimeSlot
        showMode={showMode}
        day="Thursday"
        value={dt["Thursday"]}
        setDayTime={handleChange}
      />
      <DayTimeSlot
        showMode={showMode}
        day="Friday"
        value={dt["Friday"]}
        setDayTime={handleChange}
      />
      <DayTimeSlot
        showMode={showMode}
        day="Saturday"
        value={dt["Saturday"]}
        setDayTime={handleChange}
      />
      <DayTimeSlot
        showMode={showMode}
        day="Sunday"
        value={dt["Sunday"]}
        setDayTime={handleChange}
      />
    </div>
  );
}
